/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ErrorSaleProduct } from './ErrorSaleProduct';
/**
 * 各レコードのエラーメッセージ
 */
export type ErrorMessage = {
    /**
     * エラーが発生したレコードのインデックス
     */
    recordIndex?: number;
    /**
     * バリデーションエラーの場合はrecordIndexと以下のerrorTypeを返却する。
     * - UNDER_LOWER_LIMIT：下限値を下回っています。
     * - PROHIBITED_ITEM：禁止商品があります。
     * - PBLE_ITEM：PB・留型商品は登録できません。
     * - FIFTY_DISCOUNT：50％以上乖離があるため登録不可
     * - OVER_EDLP：定番売価以上のため登録不可
     * - SALE_PRODUCT：更徳売価以上のため登録不可
     * その他のエラーの場合はrecordIndex=0,errorType=OTHERとしてエラーメッセージを返却する。
     * - OTHER：バリデーション以外のエラー
     *
     */
    errorType?: ErrorMessage.errorType;
    /**
     * エラーメッセージ
     */
    message?: string;
    data?: Array<ErrorSaleProduct>;
};
export namespace ErrorMessage {
    /**
     * バリデーションエラーの場合はrecordIndexと以下のerrorTypeを返却する。
     * - UNDER_LOWER_LIMIT：下限値を下回っています。
     * - PROHIBITED_ITEM：禁止商品があります。
     * - PBLE_ITEM：PB・留型商品は登録できません。
     * - FIFTY_DISCOUNT：50％以上乖離があるため登録不可
     * - OVER_EDLP：定番売価以上のため登録不可
     * - SALE_PRODUCT：更徳売価以上のため登録不可
     * その他のエラーの場合はrecordIndex=0,errorType=OTHERとしてエラーメッセージを返却する。
     * - OTHER：バリデーション以外のエラー
     *
     */
    export enum errorType {
        UNDER_LOWER_LIMIT = 'UNDER_LOWER_LIMIT',
        PROHIBITED_ITEM = 'PROHIBITED_ITEM',
        PBLE_ITEM = 'PBLE_ITEM',
        FIFTY_DISCOUNT = 'FIFTY_DISCOUNT',
        OVER_EDLP = 'OVER_EDLP',
        SALE_PRODUCT = 'SALE_PRODUCT',
        OTHER = 'OTHER',
    }
}

